module.exports = __webpack_public_path__ + "static/media/career_tab_img_1.19826c7a.png";